module.exports = __webpack_public_path__ + "static/media/Systems.69647dc7.svg";